import api from "./axios";

function message(error, fallback) {
  return error?.response?.data?.message || error?.message || fallback;
}

export const restaurantTablesApi = {
  async create(projectId, payload) {
    try {
      const { data } = await api.post(`/projects/${projectId}/tables`, payload);
      if (!data?.ok) throw new Error(data?.message || "No se pudo crear la mesa.");
      return data.table;
    } catch (error) {
      throw new Error(message(error, "No se pudo crear la mesa."));
    }
  },

  async getLayout(projectId, sector = "") {
    try {
      const { data } = await api.get(`/projects/${projectId}/tables/layout`, {
        params: { sector },
        headers: { "Cache-Control": "no-cache" },
      });
      if (!data?.ok) throw new Error(data?.message || "No se pudo cargar el plano de mesas.");
      return data.layout;
    } catch (error) {
      throw new Error(message(error, "No se pudo cargar el plano de mesas."));
    }
  },

  async saveLayout(projectId, payload) {
    try {
      const { data } = await api.put(`/projects/${projectId}/tables/layout`, payload);
      if (!data?.ok) throw new Error(data?.message || "No se pudo guardar la distribución.");
      return data.layout;
    } catch (error) {
      throw new Error(message(error, "No se pudo guardar la distribución."));
    }
  },
};
